/**
 * Canonical portal Home hub copy — trust voice, shared by portal-web + staff Client view.
 *
 * @see docs/superpowers/specs/2026-08-09-engagement-plan-getting-started-client-view-design.md
 */
export const ATTENTION_EMPTY = "Nothing needs you right now.";
export const SEND_TITLE = "Send to Latitude30";
export const SEND_SUBCOPY = "Files and messages go to your Latitude30 team.";
export const NAV_SHARED_DOCUMENTS = "Shared documents";
export const PUBLISHED_BRIEF_CAPTION = "Published brief — a fixed snapshot your Latitude30 team prepared for you.";
/** Trust empty template: `{thing}` / `{them}` placeholders. */
export function trustEmptyCopy(thing, them = "them") {
    return `Latitude30 hasn't shared ${thing} here yet. You'll see ${them} as soon as they're ready.`;
}
export const EMPTY_DOCUMENTS_TITLE = "Nothing shared yet";
export const EMPTY_DOCUMENTS = trustEmptyCopy("documents");
export const EMPTY_FOR_REVIEW_TITLE = "Nothing waiting for review";
export const EMPTY_FOR_REVIEW = "Nothing is waiting for your review. When Latitude30 shares a document for feedback, it will appear here.";
export const EMPTY_PUBLISHED_TITLE = "No published items yet";
export const EMPTY_PUBLISHED = trustEmptyCopy("published items");
export const EMPTY_PROJECT_PLAN_TITLE = "No project or retainer plan shared yet";
export const EMPTY_PROJECT_PLAN = trustEmptyCopy("a project or retainer plan", "it");
export const EMPTY_ENGAGEMENT_MILESTONES = "No milestones yet. Your Latitude30 contact will add the major checkpoints here.";
export const EMPTY_PROGRAMME = "Your Latitude30 team is preparing programme materials. They'll appear here as soon as they're ready.";
export const SHARED_WITH_YOU = "Shared with you";
export const SENT_BY_YOU = "Sent by you";
export const HOME_GREETING = "What needs you, where things stand, and how to reach Latitude30.";
export const CLIENT_VIEW_BANNER = "Client view · not signed in as guest";
export function contactLine(name) {
    return `Questions? Contact ${name}.`;
}
//# sourceMappingURL=portal-hub-copy.js.map